import styled from 'styled-components/native';

export default styled.TouchableOpacity`
  flex-grow: 1;
  padding: 10px;
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme.colors.primaryGhost};
  align-items: center;
`;
